import { createTheme, type Theme, type ThemeOptions } from "@mui/material/styles";
import type { DesignTokens } from "./types";
import { buildPalette } from "./palette";
import { buildTypography } from "./typography";
import { buildShadows } from "./shadows";
import { buildComponents } from "./components";

/** Assemble a MUI ThemeOptions object from a full set of design tokens. */
export function buildThemeOptions(tokens: DesignTokens): ThemeOptions {
  return {
    palette: buildPalette(tokens),
    typography: buildTypography(tokens),
    components: buildComponents(tokens),
    shadows: buildShadows(tokens),
    shape: {
      borderRadius: tokens.radius.md,
    },
  };
}

/** Create a fully resolved MUI Theme from a full set of design tokens. */
export function buildTheme(tokens: DesignTokens): Theme {
  return createTheme(buildThemeOptions(tokens));
}
